import { createSelector } from "reselect";
import { surveyWoundDetailsSelector } from "../survey_wound_details_selector";

export const surveyWoundDetailsDataSelector = createSelector(
  surveyWoundDetailsSelector,
  woundDetails => {
    return Object.values(woundDetails.data);
  }
);
